import { IReportingState } from './types';

const initialReportingState = (): IReportingState => ({
  loading: false,
  date: '',
  ictService_id: 0,
  function_id: 0,
  is_displayed: false,
  is_additional_displayed: false,
  headers: [] as string[],
  dataReport99: {},
  ict_system_by_function: 0,
  ict_system_by_ict_service: 0,
  financial_entity_lei_id: 0,
});

export default initialReportingState;
